import React from "react";

interface IProps {
  invoiceType: "noInvoice" | "customerInvoice" | "companyInvoice";
  setInvoiceType: (value: "noInvoice" | "customerInvoice" | "companyInvoice") => void;
}

const InvoiceButtons: React.FC<IProps> = ({ invoiceType, setInvoiceType }: IProps) => {
  return (
    <React.Fragment>
      <h2>Szczegóły faktury</h2>
      <div className={"invoice-button"}>
        <button onClick={() => setInvoiceType("noInvoice")} className={invoiceType === "noInvoice" ? "active" : ""}>
          Bez faktury
        </button>
        <button
          onClick={() => setInvoiceType("customerInvoice")}
          className={invoiceType === "customerInvoice" ? "active" : ""}
        >
          Faktura na osobę
        </button>
        <button
          onClick={() => setInvoiceType("companyInvoice")}
          className={invoiceType === "companyInvoice" ? "active" : ""}
        >
          Faktura na firmę
        </button>
      </div>
    </React.Fragment>
  );
};

export default InvoiceButtons;
